import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { fetchScheduleByIdQueryOptions } from "@/api/schedules";
import { useApiParameters } from "@/hooks/useApiParameters";
import { ScheduleSessionsList } from "./-components/ScheduleSessionsList";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/schedules/$scheduleId/sessions",
)({
	beforeLoad: ({ context }) => {
		if (!context.userId) {
			throw new Error("Not authenticated");
		}
	},
	loader: async ({ context, params }) => {
		const { userId, token } = useApiParameters(
			context.userId,
			await context.get_token(),
		);
		const { orgId, scheduleId } = params;

		// Preload schedule data
		context.queryClient.ensureQueryData(
			fetchScheduleByIdQueryOptions(userId, token, orgId, scheduleId),
		);

		return { userId, token, orgId, scheduleId };
	},
	component: ScheduleSessionsPage,
});

function ScheduleSessionsPage() {
	const { userId, token, orgId, scheduleId } = Route.useLoaderData();

	const { data: schedule } = useSuspenseQuery(
		fetchScheduleByIdQueryOptions(userId, token, orgId, scheduleId),
	);

	return (
		<ScheduleSessionsList
			organizationId={orgId}
			scheduleId={scheduleId}
			schedule={schedule}
			token={token}
		/>
	);
}
